/* eslint-disable */
import { get } from 'lodash';
import { Analytics } from './index';

// Interface for Storefront Data
interface StorefrontData {
  brand?: string;
  financialProduct?: {
    calculation?: {
      duration?: number;
      durationUnit?: string;
      yearlyMileage?: number;
      mileageUnit?: string;
      subsequentInstallment?: {
        amount?: number;
      };
    };
  };
  vehicleData?: {
    model?: {
      brand?: string;
      name?: string;
      descriptionLong?: string;
      engine?: {
        fuelType?: string;
      };
    };
  };
  dealerData?: {
    address?: {
      zipCode?: string;
      city?: string;
      street?: string;
      state?: string;
    };
    companyId?: string;
    companyName?: string;
  };
  [key: string]: any; // Extendable for additional unknown properties
}

// Function to Push Storefront Data to Data Layer
export function pushStorefrontDataToDatalayer(storefrontData: StorefrontData): void {
  Analytics.addToDatalayer({
    'core.category.maturityLevel': 'lead',
    'core.attributes.brand': get(storefrontData, 'brand', 'vwfs'),
    'product[0].attributes.duration': get(
      storefrontData,
      'financialProduct.calculation.duration'
    ),
    'product[0].attributes.durationUnit': get(
      storefrontData,
      'financialProduct.calculation.durationUnit'
    ),
    'product[0].attributes.yearlyMileage': get(
      storefrontData,
      'financialProduct.calculation.yearlyMileage'
    ),
    'product[0].attributes.mileageUnit': get(
      storefrontData,
      'financialProduct.calculation.mileageUnit'
    ),
    'product[0].attributes.recurringPayment': get(
      storefrontData,
      'financialProduct.calculation.subsequentInstallment.amount'
    ),
    'product[0].vehicleModel[0].manufacturer': get(
      storefrontData,
      'vehicleData.model.brand'
    ),
    'product[0].vehicleModel[0].name': get(
      storefrontData,
      'vehicleData.model.name'
    ),
    'product[0].vehicleModel[0].descriptionLong': get(
      storefrontData,
      'vehicleData.model.descriptionLong'
    ),
    'product[0].vehicleModel[0].engine.fuelType': get(
      storefrontData,
      'vehicleData.model.engine.fuelType'
    ),
    'dealerData.address.zipCode': get(
      storefrontData,
      'dealerData.address.zipCode'
    ),
    'dealerData.address.city': get(storefrontData, 'dealerData.address.city'),
    'dealerData.companyId': get(storefrontData, 'dealerData.companyId'),
    'dealerData.companyName': get(storefrontData, 'dealerData.companyName'),
    'dealerData.address.street': get(
      storefrontData,
      'dealerData.address.street'
    ),
    'dealerData.address.state': get(storefrontData, 'dealerData.address.state'),
  });
}
